import React from "react";
import "./NewPageRouts.css";
import { Route, Routes } from "react-router-dom";
import NewHomeComponents from "../NewComponents/NewHome1/NewHomeComponents";
import Cources from "./Pages/Cources/Cources";
import Chapter from "./Pages/Chapter/Chapter";
import MCQ from "./Pages/MCQ/MCQ";
import Profile from "./Pages/Profile/Profile";
import NewMyCources from "../NewComponents/NewHome1/NewMyCources";
import NewLogin from "../NewComponents/NewLogIn/NewLogin";
import LoginCheck from "../Route/LoginCheck";
import AuthCheck from "../Route/AuthCheck";

const NewPageRouts = () => {
  return (
    <div className="w-100 bg-dark pages-container">
      <Routes>
        {/* <Route path="/" element={<NewHomeComponents />} /> */}
        {/* <Route path="/cources/:id" element={<Cources />} />
        <Route path="/chapter/:id" element={<Chapter />} /> */}
        {/* <Route path="/MCQ/:id" element={<MCQ />} /> */}
        {/* <Route path="/profile" element={<Profile />} /> */}
        <Route path="/cources/:id" element={<AuthCheck cmp={Cources} />} />
        <Route path="/chapter/:id" element={<AuthCheck cmp={Chapter} />} />
        <Route path="/MCQ/:id" element={<AuthCheck cmp={MCQ} />} />
        <Route path="/" element={<AuthCheck cmp={NewHomeComponents} />} />
        <Route path="/profile" element={<AuthCheck cmp={Profile} />} />
        <Route path="/myCources" element={<AuthCheck cmp={NewMyCources} />} />
        <Route path="/login" element={<LoginCheck cmp={NewLogin} />} />
      </Routes>
    </div>
  );
};

export default NewPageRouts;
